import type { Position } from '@xleddyl/types'

export const MAP_MIN_ZOOM = 9.5

export const MAP_CENTER = [11, 43] as [number, number]

export const MAP_LIMIT = [
   [3.2023, 33.9828], // sw
   [21.7818, 49.9145], // ne
] as [Position, Position]

export const MAP_INITIAL_LIMIT = [
   [3.2023, 33.9828], // sw
   [21.7818, 49.9145], // ne
] as [Position, Position]
